import React, { ComponentProps, ReactNode } from 'react';
import { Square } from '@grubhubprod/gh-cookbook-react/dist';
import { useFeatureFlag } from 'src/hooks/useFeatureFlag';
import { FeatureFlag } from 'src/types/FeatureFlag';
import {
  getPageSectionBorderRadius,
  getPageSectionDimension,
} from 'src/components/selfService/layout/PageSection/pageSectionUtils/pageSectionUtils';

export interface PageSectionProps {
  bg?: ComponentProps<typeof Square>['bg'];
  borderRadius?: ComponentProps<typeof Square>['borderRadius'];
  dataTestId?: string;
  children: ReactNode;
}

export const PageSection: React.FC<PageSectionProps> = ({
  children,
  bg = 'untintedBackground',
  borderRadius,
  dataTestId,
}) => {
  const { isLoading: isBalanceUiLoading, value: isBalanceUiEnabled } =
    useFeatureFlag(FeatureFlag.ENABLE_BALANCE_UI);

  const appliedBorderRadius = getPageSectionBorderRadius(
    isBalanceUiEnabled,
    isBalanceUiLoading,
    borderRadius
  );
  const appliedDimension = getPageSectionDimension(
    isBalanceUiEnabled,
    isBalanceUiLoading
  );

  return (
    <Square
      bg={bg}
      borderRadius={appliedBorderRadius}
      data-testid={dataTestId}
      dimension={appliedDimension}
      inset="lg"
    >
      {children}
    </Square>
  );
};
